module.exports = __webpack_public_path__ + "img/map.a65fab82.png";